module.exports = __webpack_public_path__ + "static/stairlift1-f125f614007c08f0c4ac6b61f8a55bdf.jpg";